import { useQuery } from "react-query";

import { merchantsService } from "services";

type UseGetAgentInfoQueryProps = {
	id: string;
	setIsForbidden?: Function;
};

const useGetAgentDataForSplitQuery = ({
	id,
	setIsForbidden,
}: UseGetAgentInfoQueryProps) => {
	const queryResult = useQuery(
		["agentData", id],
		() => {
			return merchantsService.getAgent(id);
		},
		{
			enabled: !!id,

			retry(failureCount, error) {
				if (failureCount < 3) {
					if (error && String(error).indexOf("403") !== -1) {
						setIsForbidden?.(true);
						return false;
					}
					return true;
				} else {
					return false;
				}
			},
		},
	);

	return queryResult;
};

export default useGetAgentDataForSplitQuery;
